export default __webpack_public_path__ + "static/media/atuacao.ba89d7b0.png";